import React, { useState, useRef } from 'react';
import { CheckCircle, XCircle, X, TriangleAlert  } from 'lucide-react';

// Custom Popup Component
const CustomPopup = ({ isOpen, onClose, type, message }) => {
  if (!isOpen) return null;

  const isSuccess = type === 'success';

  return (
    <div 
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        animation: 'fadeIn 0.3s ease-out'
      }}
    >
      {/* Backdrop */}
      <div 
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.3s ease-out'
        }}
        onClick={onClose}
      />
      
      {/* Popup */}
      <div 
        style={{
          position: 'relative',
          backgroundColor: 'white',
          borderRadius: '1rem',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: '28rem',
          width: '100%',
          padding: '1.5rem',
          animation: 'slideUp 0.4s ease-out'
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            color: '#9CA3AF',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0.25rem',
            transition: 'color 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.color = '#4B5563'}
          onMouseOut={(e) => e.currentTarget.style.color = '#9CA3AF'}
        >
          <X size={24} />
        </button>

        {/* Icon with animation */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
          <div style={{ 
            color: isSuccess ? '#10B981' : '#293c98',
            animation: 'scaleIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
          }}>
            {isSuccess ? (
              <CheckCircle size={64} style={{ animation: 'bounce 1s infinite' }} />
            ) : (
              <TriangleAlert size={64} style={{ animation: 'shake 0.5s ease-in-out' }} />
            )}
          </div>
        </div>

        {/* Title */}
        <h3 style={{
          fontSize: '1.5rem',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '0.5rem',
          color: isSuccess ? '#059669' : '#293c98'
        }}>
          {isSuccess ? 'Success!' : 'Error!'}
        </h3>

        {/* Message */}
        <p style={{
          color: '#6B7280',
          textAlign: 'center',
          marginBottom: '1.5rem'
        }}>
          {message}
        </p>

        {/* Action Button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            borderRadius: '0.5rem',
            fontWeight: '600',
            color: 'white',
            backgroundColor: isSuccess ? '#293c98' : '#293c98',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.2s',
            transform: 'scale(1)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = isSuccess ? '#DC2626' : '#DC2626';
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = isSuccess ? '#293c98' : '#293c98';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {isSuccess ? 'OK' : 'Try Again'}
        </button>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes scaleIn {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-10px); }
          75% { transform: translateX(10px); }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};



export default CustomPopup;